import { Check, X, Sun, CloudRain, Sparkles, Wind, Thermometer } from "lucide-react";

function ComparisonCell({ value }) {
    if (value === true) return <Check size={18} style={{ color: "var(--success)" }} />;
    if (value === false) return <X size={18} style={{ color: "var(--text-3)" }} />;
    return <span className="text-sm" style={{ color: "var(--text)" }}>{value}</span>;
}


/**
 * Productvergelijking: Metamark M4 (Mat) vs M7 (Glanzend).
 * Vlaggen + tabel + duidelijke "Kies M4 als..." / "Kies M7 als..." rijen.
 */
export default function MetamarkComparison({ compact = false }) {
    const rows = [
        { label: "Afwerking",          m4: "Mat / gesatineerd",       m7: "Hoogglans",                icon: Sparkles },
        { label: "Levensduur (buiten)", m4: "Tot 7 jaar",              m7: "Tot 8-10 jaar",            icon: Sun },
        { label: "UV-bestendig",       m4: true,                       m7: true,                       icon: Sun },
        { label: "Waterproof",         m4: true,                       m7: true,                       icon: CloudRain },
        { label: "Krasbestendig",      m4: "Goed",                     m7: "Uitstekend",               icon: Wind },
        { label: "Reflectie / glans",  m4: false,                      m7: true,                       icon: Sparkles },
        { label: "Auto-carrosserie",   m4: "Aanbevolen",               m7: "Premium look",             icon: Thermometer },
        { label: "Ramen / glas",       m4: "Geen reflectie",           m7: "Iets meer glans",          icon: CloudRain },
        { label: "Helm / motor",       m4: "Subtiel",                  m7: "Sportieve look",           icon: Wind },
        { label: "Prijs",              m4: "Standaard",                m7: "+10-15%",                  icon: Thermometer },
    ];

    return (
        <div data-testid="metamark-comparison" className={`rounded-3xl bg-white shadow-[0_8px_32px_rgba(62,39,35,0.06)] ${compact ? "p-5" : "p-8"} border border-[var(--border-soft)]`}>
            <div className="flex items-baseline justify-between flex-wrap gap-2 mb-2">
                <div>
                    <p className="label-tiny" style={{ color: "var(--rose-deep)" }}>★ Productvergelijking</p>
                    <h3 className={`font-display ${compact ? "text-2xl" : "text-3xl md:text-4xl"} mt-1 leading-tight`}>
                        Metamark M4 vs <span className="italic" style={{ color: "var(--rose-deep)" }}>M7</span>
                    </h3>
                </div>
                <p className="text-xs max-w-sm" style={{ color: "var(--text-2)" }}>
                    Beide premium mono-kleur vinyls — kies puur op de afwerking die je wil.
                </p>
            </div>

            {/* Header row */}
            <div className="mt-5 grid grid-cols-[1fr_120px_120px] sm:grid-cols-[1.4fr_1fr_1fr] gap-2 pb-3 border-b border-[var(--border-soft)]">
                <span className="label-tiny">Eigenschap</span>
                <div className="text-center">
                    <p className="font-display text-lg" style={{ color: "var(--text)" }}>M4</p>
                    <p className="label-tiny" style={{ color: "var(--text-3)" }}>Mat</p>
                </div>
                <div className="text-center">
                    <p className="font-display text-lg" style={{ color: "var(--rose-deep)" }}>M7</p>
                    <p className="label-tiny" style={{ color: "var(--text-3)" }}>Glanzend</p>
                </div>
            </div>

            <ul className="divide-y divide-[var(--border-soft)]">
                {rows.map((r) => {
                    const Icon = r.icon;
                    return (
                        <li key={r.label} className="grid grid-cols-[1fr_120px_120px] sm:grid-cols-[1.4fr_1fr_1fr] gap-2 py-3 items-center" data-testid={`mm-row-${r.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                            <span className="text-sm inline-flex items-center gap-2" style={{ color: "var(--text)" }}>
                                <Icon size={13} style={{ color: "var(--text-3)" }} /> {r.label}
                            </span>
                            <div className="text-center"><ComparisonCell value={r.m4} /></div>
                            <div className="text-center"><ComparisonCell value={r.m7} /></div>
                        </li>
                    );
                })}
            </ul>

            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="p-4 rounded-2xl" style={{ background: "var(--bg-warm)" }} data-testid="mm-pick-m4">
                    <p className="label-tiny" style={{ color: "var(--text-2)" }}>Kies M4 als</p>
                    <p className="text-sm mt-1.5 leading-relaxed">je een subtiele, niet-reflecterende look wil — perfect voor leasewagens, raamtekst en bedrijfsbelettering.</p>
                    <p className="text-[11px] mt-2 inline-flex items-center gap-1.5 px-2 py-1 rounded-full" style={{ background: "rgba(107, 142, 90, 0.15)", color: "var(--success)" }}>
                        ✓ Vaak op voorraad
                    </p>
                </div>
                <div className="p-4 rounded-2xl" style={{ background: "var(--rose-tint)" }} data-testid="mm-pick-m7">
                    <p className="label-tiny" style={{ color: "var(--rose-deep)" }}>Kies M7 als</p>
                    <p className="text-sm mt-1.5 leading-relaxed">je een opvallende, premium uitstraling wil — denk sportwagens, helmen of statement-belettering met diepte.</p>
                    <p className="text-[11px] mt-2 inline-flex items-center gap-1.5 px-2 py-1 rounded-full" style={{ background: "rgba(201, 168, 118, 0.20)", color: "var(--text)" }}>
                        ⏱ Enkel op bestelling — productietijd 3-7 werkdagen
                    </p>
                </div>
            </div>
        </div>
    );
}
